var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecents({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    clipRule: "evenodd",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke fill",
    d: "M11.241 43.022a1.21 1.21 0 0 0-1.724.879L6.242 62.368a1.21 1.21 0 0 0 1.744 1.292l20.14-10.262a1.213 1.213 0 0 0-.02-2.17z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M38.972 19.44V37.5l10.874 8.638"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M66.766 26.931A29.6 29.6 0 0 1 68.702 37.5c0 16.409-13.321 29.73-29.73 29.73-8.377 0-15.949-3.472-21.355-9.054m-6.438-31.245C15.444 15.734 26.285 7.77 38.972 7.77c3.837 0 7.505.728 10.874 2.054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecents);
export default __webpack_public_path__ + "static/media/recents.38f72d314102d4daf54c3974c8fa3216.svg";
export { ForwardRef as ReactComponent };